/**
 * Converts a string value to a boolean value.
 * @param value - The value to convert.
 * @returns The boolean value.
 */
export const stringToBoolean = (value) => {
    if (!value)
        return false;
    switch (value.toLowerCase().trim()) {
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
            return false;
        default:
            return Boolean(value);
    }
};
